const TermsOfService = () => (
  <div style={{ padding: "2rem" }}>
    <h1>Terms of Service</h1>
    <p>
      By using our services, you agree to comply with our terms. Misuse of the platform may result in account restrictions.
    </p>
  </div>
);
export default TermsOfService;
